import React, {useEffect} from 'react';
import {matchPath} from 'react-router';
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {routes} from '../../../../../../core/models/static/routes/app-routes';
import useAccessLevels from '../../../../../hooks/use-access-levels';
import AdminReviewQueueView from './review-queue';
import AdminWalletOperationsView from './wallet-operations';
import AdminBusinessConfigView from './business-config';
import AdminLiabilityReportView from './liability-report';
import AdminAuditLogView from './audit-log';
import AdminPurchaseConfirmView from './purchase-confirm';

const BizPointAdminViews = () => {
    const location = useLocation();
    const history = useHistory();
    const {packages} = useAccessLevels();
    const canWalletOperations = packages.bizPoint.adminManualAdjustment || packages.bizPoint.adminWalletSuspend;

    /**
     * Redirect to the first available admin sub-section from the base path.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.bizPoint.admin.base, exact: true})) {
            if (packages.bizPoint.adminReviewQueue) {
                history.replace(routes.bizPoint.admin.reviewQueue);
            } else if (canWalletOperations) {
                history.replace(routes.bizPoint.admin.walletOperations);
            } else if (packages.bizPoint.adminBusinessConfig) {
                history.replace(routes.bizPoint.admin.businessConfig);
            } else if (packages.bizPoint.adminLiabilityReport) {
                history.replace(routes.bizPoint.admin.liabilityReport);
            } else if (packages.bizPoint.adminAuditLog) {
                history.replace(routes.bizPoint.admin.auditLog);
            } else if (packages.bizPoint.adminPurchaseConfirm) {
                history.replace(routes.bizPoint.admin.purchaseConfirm);
            } else {
                history.replace(routes.bizPoint.admin.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [
        packages.bizPoint.adminAuditLog,
        packages.bizPoint.adminBusinessConfig,
        packages.bizPoint.adminLiabilityReport,
        packages.bizPoint.adminPurchaseConfirm,
        packages.bizPoint.adminReviewQueue,
        canWalletOperations,
        history,
        location.pathname,
    ]);

    return (
        <Switch>
            <Route path={routes.bizPoint.admin.base} exact/>
            {
                packages.bizPoint.adminReviewQueue &&
                <Route path={routes.bizPoint.admin.reviewQueue} exact>
                    <AdminReviewQueueView/>
                </Route>
            }
            {
                canWalletOperations &&
                <Route path={routes.bizPoint.admin.walletOperations} exact>
                    <AdminWalletOperationsView/>
                </Route>
            }
            <Redirect
                from={routes.bizPoint.admin.manualAdjustment}
                to={routes.bizPoint.admin.walletOperations}
            />
            <Redirect
                from={routes.bizPoint.admin.walletSuspend}
                to={routes.bizPoint.admin.walletOperations}
            />
            {
                packages.bizPoint.adminBusinessConfig &&
                <Route path={routes.bizPoint.admin.businessConfig} exact>
                    <AdminBusinessConfigView/>
                </Route>
            }
            {
                packages.bizPoint.adminLiabilityReport &&
                <Route path={routes.bizPoint.admin.liabilityReport} exact>
                    <AdminLiabilityReportView/>
                </Route>
            }
            {
                packages.bizPoint.adminAuditLog &&
                <Route path={routes.bizPoint.admin.auditLog} exact>
                    <AdminAuditLogView/>
                </Route>
            }
            {
                packages.bizPoint.adminPurchaseConfirm &&
                <Route path={routes.bizPoint.admin.purchaseConfirm} exact>
                    <AdminPurchaseConfirmView/>
                </Route>
            }
            <Redirect to={routes.bizPoint.admin.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default BizPointAdminViews;
